import * as effects from 'redux-saga/effects';

import { api } from '@REST/api';
import { handleError } from '@bus/ui/saga/workers/handleError';
import { throwError } from '@bus/ui/saga/workers/throwError';
import { metametricsActions } from '@bus/metametrics/actions';
import {
  FetchMetametricsCardActionPayload,
  FillMetametricsCardActionPayload,
} from '@bus/metametrics/typedefs';
import { PayloadAction } from '@reduxjs/toolkit';

export function* fetchMetametricsCard({
  payload,
}: PayloadAction<FetchMetametricsCardActionPayload>) {
  try {
    yield effects.put(metametricsActions.startFetching());
    const response: Response = yield effects.apply(api, api.get, [
      { endpoint: `metametrics/${payload.id}/` },
    ]);
    if (!response.ok) {
      yield throwError(response);
    }
    const data: FillMetametricsCardActionPayload = yield effects.call([
      response,
      'json',
    ]);

    yield effects.put(metametricsActions.fillMetametricsCard(data));
  } catch (e) {
    yield handleError(e);
  } finally {
    yield effects.put(metametricsActions.stopFetching());
  }
}
